export class CetelemUtilities {
  static shouldShowCETELEMIndicator(agreement: boolean): boolean {
    // Add more logic if it is needed to show the CELETEM indicator
    return agreement;
  }
}
